export default __webpack_public_path__ + "static/media/braxos.e48e6761.png";